export const endpoints = {
  vendor: (host: string, vendor: string) =>
    `${host}/embedded-player/v1/vendors/${vendor}`,
};
